import { render, staticRenderFns } from "./resend_invite.vue?vue&type=template&id=252bf72f&"
import script from "./resend_invite.vue?vue&type=script&lang=js&"
export * from "./resend_invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports